import React, { useEffect, useState } from 'react';
import pb from '../lib/pocketbase';
import TiptapEditor from './TiptapEditor';
import './Admin.css';

export default function AdminLegalManager() {
    const [content, setContent] = useState('');
    const [recordId, setRecordId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [isDirty, setIsDirty] = useState(false);
    const [toast, setToast] = useState({ show: false, message: '', type: 'success' });

    const showToast = (message, type = 'success') => {
        setToast({ show: true, message, type });
        setTimeout(() => setToast(prev => ({ ...prev, show: false })), 3000);
    };

    useEffect(() => {
        fetchLegalContent();
    }, []);

    const fetchLegalContent = async () => {
        setLoading(true);
        try {
            // Try to get the first record from the 'legal' collection
            const records = await pb.collection('legal').getFullList({
                sort: '-created',
                max: 1
            });

            if (records.length > 0) {
                setContent(records[0].content || '');
                setRecordId(records[0].id);
            }
        } catch (err) {
            console.error("Error fetching legal content:", err);
            showToast("Erreur lors du chargement des mentions légales", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async (e) => {
        if (e) e.preventDefault();
        setSaving(true);
        try {
            if (recordId) {
                await pb.collection('legal').update(recordId, { content });
            } else {
                const newRecord = await pb.collection('legal').create({ content });
                setRecordId(newRecord.id);
            }
            showToast("Mentions légales enregistrées avec succès !");
            setIsDirty(false);
        } catch (err) {
            console.error("Error saving legal content:", err);
            showToast("Erreur lors de l'enregistrement", "error");
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return (
            <div className="admin-loader-container">
                <div className="loader"></div>
                <p>Chargement des mentions légales...</p>
            </div>
        );
    }

    return (
        <div className="admin-legal-manager">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
                <h1 className="admin-title-gradient">Gestion des Mentions Légales</h1>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    {isDirty && <span className="dirty-badge">● Modifié</span>}
                    <button
                        className={`btn btn-primary ${isDirty ? 'btn-save-dirty' : ''}`}
                        onClick={handleSave}
                        disabled={saving}
                    >
                        {saving ? 'Enregistrement...' : 'Enregistrer'}
                    </button>
                </div>
            </div>

            <div className="card" style={{ padding: '2rem' }}>
                <div className="form-group">
                    <label style={{ marginBottom: '1rem', display: 'block', fontWeight: 'bold' }}>
                        Contenu des mentions légales et politique de confidentialité
                    </label>
                    <TiptapEditor
                        content={content}
                        onChange={(val) => {
                            setContent(val);
                            setIsDirty(true);
                        }}
                    />
                </div>
            </div>

            {toast.show && (
                <div className={`admin-toast ${toast.type}`}>
                    {toast.message}
                </div>
            )}
        </div>
    );
}
